var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c(
        "div",
        { staticClass: "login-page" },
        [
          _c(
            "v-layout",
            { staticClass: "login-container" },
            [
              _c("div", { staticClass: "mb-3" }, [
                _c(
                  "div",
                  { staticStyle: { "justify-items": "center" } },
                  [
                    _vm.logoPath
                      ? _c("v-img", {
                          staticClass: "customer-logo mb-2",
                          attrs: {
                            src: _vm.logoPath,
                            alt: "Customer Logo",
                            width: "100"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-img", {
                      attrs: {
                        src:
                          _vm.siteUrl +
                          "/images/SPHEREboard_Logo_2024_white.svg",
                        alt: "SPHEREboard Logo",
                        width: "220"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.showWarning
                ? _c("div", { staticClass: "warning-message" }, [
                    _c("span", [_vm._v(_vm._s(_vm.errorMessage))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "login_form",
                  staticClass: "input-fields",
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _vm.idpTypeNames.find(function(x) {
                    return x == "Local Active Directory"
                  })
                    ? _c("v-text-field", {
                        staticClass: "bordered-input",
                        attrs: {
                          label: "Username",
                          rules: [
                            function(v) {
                              return (
                                (v != null && !!v) || "Username is required"
                              )
                            }
                          ],
                          placeholder: "Enter username"
                        },
                        on: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.continueWithLocalAD($event)
                          }
                        },
                        model: {
                          value: _vm.userName,
                          callback: function($$v) {
                            _vm.userName = $$v
                          },
                          expression: "userName"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.idpTypeNames.find(function(x) {
                    return x == "Local Active Directory"
                  })
                    ? _c("v-text-field", {
                        staticClass: "bordered-input password-input-size",
                        attrs: {
                          "append-icon": _vm.visible
                            ? "visibility"
                            : "visibility_off",
                          type: _vm.visible ? "text" : "password",
                          label: "Password",
                          placeholder: "Enter password",
                          rules: [
                            function(v) {
                              return (
                                (v != null && !!v) || "Password is required"
                              )
                            }
                          ]
                        },
                        on: {
                          "click:append": function($event) {
                            _vm.visible = !_vm.visible
                          },
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.continueWithLocalAD($event)
                          }
                        },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.idpTypeNames.find(function(x) {
                    return x == "Local Active Directory"
                  })
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-custom btn-continue",
                          attrs: { color: "#fdb913", size: "large" },
                          on: { click: _vm.continueWithLocalAD }
                        },
                        [_vm._v("Continue")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.idpTypeNames.find(function(x) {
                    return x == "Local Active Directory"
                  }) &&
                  (_vm.idpTypeNames.find(function(x) {
                    return x == "Microsoft Entra"
                  }) ||
                    _vm.idpTypeNames.find(function(x) {
                      return x == "Okta"
                    }) ||
                    _vm.idpTypeNames.find(function(x) {
                      return x == "PingOne"
                    }) ||
                    _vm.idpTypeNames.find(function(x) {
                      return x == "PingFederate"
                    }))
                    ? _c(
                        "v-layout",
                        {
                          staticClass: "login-divider py-2",
                          attrs: { "align-center": "" }
                        },
                        [
                          _c(
                            "v-flex",
                            [_c("v-divider", { staticClass: "divider" })],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "px-3" }, [
                            _c("span", { staticClass: "color_white" }, [
                              _vm._v("or")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            [_c("v-divider", { staticClass: "divider" })],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.idpTypeNames.find(function(x) {
                    return x == "Microsoft Entra"
                  })
                    ? _c(
                        "v-btn",
                        {
                          staticClass:
                            "btn-custom btn-idp mt-2 d-flex align-center justify-center",
                          attrs: {
                            color: _vm.idpTypeNames.find(function(x) {
                              return x == "Local Active Directory"
                            })
                              ? "#cfdce7"
                              : "#fdb913",
                            size: "large"
                          },
                          on: { click: _vm.continueWithMicrosoft }
                        },
                        [
                          _c("v-img", {
                            staticClass: "mr-2",
                            attrs: {
                              src: _vm.siteUrl + "/images/EntraID.png",
                              alt: "Microsoft Logo",
                              contain: "",
                              "max-height": "24",
                              "max-width": "24"
                            }
                          }),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.getConfigurationName("Microsoft Entra")
                              )
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.idpTypeNames.find(function(x) {
                    return x == "Okta"
                  })
                    ? _c(
                        "v-btn",
                        {
                          staticClass:
                            "btn-custom btn-idp d-flex align-center justify-center",
                          class: _vm.idpTypeNames.find(function(x) {
                            return x == "Microsoft Entra"
                          })
                            ? "mt-3"
                            : "mt-2",
                          attrs: {
                            color: _vm.idpTypeNames.find(function(x) {
                              return x == "Local Active Directory"
                            })
                              ? "#cfdce7"
                              : "#fdb913",
                            size: "large"
                          },
                          on: { click: _vm.continueWithOkta }
                        },
                        [
                          _c("v-img", {
                            staticClass: "mr-2",
                            attrs: {
                              src: _vm.siteUrl + "/images/okta_logo.png",
                              alt: "Okta Logo",
                              contain: "",
                              "max-height": "24",
                              "max-width": "24"
                            }
                          }),
                          _vm._v(_vm._s(_vm.getConfigurationName("Okta")))
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.idpTypeNames.find(function(x) {
                    return x == "PingOne"
                  })
                    ? _c(
                        "v-btn",
                        {
                          staticClass:
                            "btn-custom btn-idp d-flex align-center justify-center",
                          class: _vm.idpTypeNames.find(function(x) {
                            return x == "Microsoft Entra" || x == "Okta"
                          })
                            ? "mt-3"
                            : "mt-2",
                          attrs: {
                            color: _vm.idpTypeNames.find(function(x) {
                              return x == "Local Active Directory"
                            })
                              ? "#cfdce7"
                              : "#fdb913",
                            size: "large"
                          },
                          on: { click: _vm.continueWithPingOne }
                        },
                        [
                          _c("v-img", {
                            staticClass: "mr-2",
                            attrs: {
                              src: _vm.siteUrl + "/images/ping_logo.png",
                              alt: "Okta Logo",
                              contain: "",
                              "max-height": "24",
                              "max-width": "24"
                            }
                          }),
                          _vm._v(_vm._s(_vm.getConfigurationName("PingOne")))
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.idpTypeNames.find(function(x) {
                    return x == "PingFederate"
                  })
                    ? _c(
                        "v-btn",
                        {
                          staticClass:
                            "btn-custom btn-idp d-flex align-center justify-center",
                          class: _vm.idpTypeNames.find(function(x) {
                            return (
                              x == "Microsoft Entra" ||
                              x == "Okta" ||
                              x == "PingOne"
                            )
                          })
                            ? "mt-3"
                            : "mt-2",
                          attrs: {
                            color: _vm.idpTypeNames.find(function(x) {
                              return x == "Local Active Directory"
                            })
                              ? "#cfdce7"
                              : "#fdb913",
                            size: "large"
                          },
                          on: { click: _vm.continueWithPingFederate }
                        },
                        [
                          _c("v-img", {
                            staticClass: "mr-2",
                            attrs: {
                              src: _vm.siteUrl + "/images/ping_logo.png",
                              alt: "Okta Logo",
                              contain: "",
                              "max-height": "24",
                              "max-width": "24"
                            }
                          }),
                          _vm._v(
                            _vm._s(_vm.getConfigurationName("PingFederate"))
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }